(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["style-selector"] && !Shopify.designMode) return;
  try {
    (function(){
  function initSelector(selector){
    if(!selector || selector.dataset.sgReady==='true')return;
    selector.dataset.sgReady='true';

    var cards=Array.from(selector.querySelectorAll('[data-sg-style-card]'));
    if(!cards.length)return;

    var current=cards.find(function(card){return card.dataset.current==='true'})||cards[0];
    var params=new URLSearchParams(window.location.search);
    var requestedAudience=params.get('audience')||'';
    var requestedTee=params.get('tee_style')||'';
    var requestedVersion=params.get('version')||'';

    function unique(values){
      return values.filter(function(value,index,array){return value&&array.indexOf(value)===index});
    }

    function availableAudiences(){
      var values=unique(cards.map(function(card){return card.dataset.audience||''}));
      var preferred=["Men's / Unisex","Women's"];
      return preferred.filter(function(value){return values.indexOf(value)!==-1}).concat(values.filter(function(value){return preferred.indexOf(value)===-1}));
    }

    var audiences=availableAudiences();
    var currentAudience=current.dataset.audience||'';
    var selectedAudience='';
    if(requestedAudience&&audiences.indexOf(requestedAudience)!==-1)selectedAudience=requestedAudience;
    else if(currentAudience&&audiences.indexOf(currentAudience)!==-1)selectedAudience=currentAudience;
    else if(audiences.length)selectedAudience=audiences[0];

    function matchesAudience(card,audience){
      var cardAudience=card.dataset.audience||'';
      return !cardAudience||!audience||cardAudience===audience;
    }

    function teeStylesFor(garment,audience){
      return unique(cards.filter(function(card){
        return card.dataset.garment===garment&&matchesAudience(card,audience);
      }).map(function(card){return card.dataset.teeStyle||''}));
    }

    function versionsFor(garment,audience,teeStyle){
      return unique(cards.filter(function(card){
        if(card.dataset.garment!==garment||!matchesAudience(card,audience))return false;
        var cardTee=card.dataset.teeStyle||'';
        if(teeStyle&&cardTee&&cardTee!==teeStyle)return false;
        return true;
      }).map(function(card){return card.dataset.version||''}));
    }

    var currentGarment=current.dataset.garment||'';
    var teeStyles=teeStylesFor(currentGarment,selectedAudience);
    var currentTee=current.dataset.teeStyle||'';
    var selectedTee='';
    if(requestedTee&&teeStyles.indexOf(requestedTee)!==-1)selectedTee=requestedTee;
    else if(currentTee&&teeStyles.indexOf(currentTee)!==-1)selectedTee=currentTee;
    else if(teeStyles.length)selectedTee=teeStyles[0];

    var versions=versionsFor(currentGarment,selectedAudience,selectedTee).sort(function(a,b){
      var matchA=/^V(\d+)$/i.exec(a);
      var matchB=/^V(\d+)$/i.exec(b);
      if(matchA&&matchB)return parseInt(matchA[1],10)-parseInt(matchB[1],10);
      if(matchA)return -1;
      if(matchB)return 1;
      return a.localeCompare(b);
    });
    var currentVersion=current.dataset.version||'';
    var selectedVersion='';
    if(requestedVersion&&versions.indexOf(requestedVersion)!==-1)selectedVersion=requestedVersion;
    else if(currentVersion&&versions.indexOf(currentVersion)!==-1)selectedVersion=currentVersion;
    else if(versions.length)selectedVersion=versions[0];

    function scoreCard(card,garment,audience,teeStyle,version){
      if(card.dataset.garment!==garment)return -9999;
      if(!matchesAudience(card,audience))return -9999;

      var score=0;
      var cardAudience=card.dataset.audience||'';
      var cardTee=card.dataset.teeStyle||'';
      var cardVersion=card.dataset.version||'';

      if(cardAudience&&audience&&cardAudience===audience)score+=30;
      else if(!cardAudience)score+=15;

      if(teeStyle){
        if(cardTee===teeStyle)score+=30;
        else if(!cardTee)score+=8;
        else score-=40;
      }else{
        if(!cardTee)score+=12;
        else score+=4;
      }

      if(version){
        if(cardVersion===version)score+=40;
        else if(!cardVersion)score+=5;
        else return -9999;
      }else if(!cardVersion){
        score+=4;
      }

      if(card.dataset.current==='true')score+=50;
      return score;
    }

    function bestCard(garment,audience,teeStyle,version){
      var best=null;
      var bestScore=-9999;
      cards.forEach(function(card){
        var score=scoreCard(card,garment,audience,teeStyle,version);
        if(score>bestScore){bestScore=score;best=card}
      });
      return bestScore>-9999?best:null;
    }

    function garmentOrder(){
      var values=[];
      cards.forEach(function(card){
        var garment=card.dataset.garment||'';
        if(garment&&values.indexOf(garment)===-1)values.push(garment);
      });
      var rank={
        't-shirt':0,
        'tshirt':0,
        'women t-shirt':0,
        'womens t-shirt':0,
        "women's t-shirt":0,
        'long sleeve':1,
        'long sleeve t-shirt':1,
        'long-sleeve':1,
        'hoodie':2,
        'crew neck':3,
        'crewneck':3,
        'crew-neck':3,
        'sweatshirt':3,
        'tank top':4,
        'tank':4
      };
      return values.map(function(value,index){
        var key=value.toLowerCase().trim();
        return {value:value,index:index,rank:Object.prototype.hasOwnProperty.call(rank,key)?rank[key]:100};
      }).sort(function(a,b){
        return a.rank===b.rank?a.index-b.index:a.rank-b.rank;
      }).map(function(item){return item.value});
    }

    function setCardHref(card){
      if(!card||!card.href)return;
      var url=new URL(card.href,window.location.origin);
      if(selectedAudience)url.searchParams.set('audience',selectedAudience);
      else url.searchParams.delete('audience');
      if(selectedTee)url.searchParams.set('tee_style',selectedTee);
      else url.searchParams.delete('tee_style');
      if(selectedVersion)url.searchParams.set('version',selectedVersion);
      else url.searchParams.delete('version');
      card.href=url.toString();
    }

    function renderGrid(){
      cards.forEach(function(card){
        card.hidden=true;
        card.classList.remove('is-active');
        card.removeAttribute('aria-current');
        card.style.order='';
      });

      garmentOrder().forEach(function(garment,index){
        var chosen=bestCard(garment,selectedAudience,selectedTee,selectedVersion);
        if(!chosen)return;
        chosen.hidden=false;
        chosen.style.order=String(index);
        setCardHref(chosen);
        if(chosen.dataset.current==='true'){
          chosen.classList.add('is-active');
          chosen.setAttribute('aria-current','page');
        }
      });
    }

    function navigateTo(card,audience,teeStyle,version){
      if(!card||!card.href)return;
      var url=new URL(card.href,window.location.origin);
      if(audience)url.searchParams.set('audience',audience);
      else url.searchParams.delete('audience');
      if(teeStyle)url.searchParams.set('tee_style',teeStyle);
      else url.searchParams.delete('tee_style');
      if(version)url.searchParams.set('version',version);
      else url.searchParams.delete('version');
      window.location.href=url.toString();
    }

    function renderTabs(container,values,selected,onSelect,labelFor){
      container.innerHTML='';
      values.forEach(function(value){
        var button=document.createElement('button');
        button.type='button';
        button.className='sg-style-tab';
        button.textContent=labelFor?labelFor(value):value;
        button.setAttribute('aria-pressed',value===selected?'true':'false');
        if(value===selected)button.classList.add('is-active');
        button.addEventListener('click',function(){onSelect(value)});
        container.appendChild(button);
      });
    }

    var audienceRow=selector.querySelector('[data-sg-audience-row]');
    var audienceTabs=selector.querySelector('[data-sg-audience-tabs]');
    if(audiences.length>1){
      audienceRow.hidden=false;
      renderTabs(audienceTabs,audiences,selectedAudience,function(nextAudience){
        var target=bestCard(currentGarment,nextAudience,selectedTee,selectedVersion);
        navigateTo(target,nextAudience,selectedTee,selectedVersion);
      });
    }else{
      audienceRow.hidden=true;
    }

    var versionRow=selector.querySelector('[data-sg-version-row]');
    var versionTabs=selector.querySelector('[data-sg-version-tabs]');
    if(versions.length>1){
      versionRow.hidden=false;
      renderTabs(versionTabs,versions,selectedVersion,function(nextVersion){
        var target=bestCard(currentGarment,selectedAudience,selectedTee,nextVersion);
        navigateTo(target,selectedAudience,selectedTee,nextVersion);
      },function(value){
        var match=/^V(\d+)$/i.exec(value);
        return match?'Version '+match[1]:value;
      });
    }else{
      versionRow.hidden=true;
    }

    var teeRow=selector.querySelector('[data-sg-tee-row]');
    var teeTabs=selector.querySelector('[data-sg-tee-tabs]');
    if(teeStyles.length>1){
      teeRow.hidden=false;
      renderTabs(teeTabs,teeStyles,selectedTee,function(nextTee){
        var target=bestCard(currentGarment,selectedAudience,nextTee,selectedVersion);
        navigateTo(target,selectedAudience,nextTee,selectedVersion);
      });
    }else{
      teeRow.hidden=true;
    }

    renderGrid();
  }

  function initAll(root){
    if(!root)return;
    if(root.matches&&root.matches('[data-sg-style-selector]'))initSelector(root);
    if(root.querySelectorAll){
      root.querySelectorAll('[data-sg-style-selector]').forEach(initSelector);
    }
  }

  function boot(){
    initAll(document);

    var observer=new MutationObserver(function(mutations){
      mutations.forEach(function(mutation){
        mutation.addedNodes.forEach(function(node){
          if(node.nodeType!==1)return;

          if(node.matches&&node.matches('[data-sg-style-selector]')){
            initSelector(node);
            return;
          }

          var selector=node.closest&&node.closest('[data-sg-style-selector]');
          var addedStyleCard=(node.matches&&node.matches('[data-sg-style-card]'))||(node.querySelector&&node.querySelector('[data-sg-style-card]'));

          if(selector&&addedStyleCard){
            selector.dataset.sgReady='false';
            initSelector(selector);
            return;
          }

          initAll(node);
        });
      });
    });

    observer.observe(document.body,{childList:true,subtree:true});

    document.addEventListener('shopify:section:load',function(event){
      initAll(event.target);
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',boot,{once:true});
  }else{
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
